import { Provider } from "./provider";

export class SpecialtyProviderConfig {
  id: string;
  provider: Provider;
  specialty: any;
  maxDuration: number;
  availableHours: string;
  timezone: string;

  constructor(from?:SpecialtyProviderConfig) {
        if(from) {
            this.id = from.id;
            this.provider = from.provider;
            this.specialty = from.specialty;
            this.maxDuration= from.maxDuration;
            this.availableHours = from.availableHours;
            this.timezone = from.timezone
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/classes/specialtyProviderConfig.ts